import { db, LocalUser } from '@/shared/lib/db'
import { auth } from '../services/firebaseAuth'
import { onAuthStateChanged } from '@firebase/auth'
import { buildLocalUser, getUserProfile } from '../services/userProfile'
import { syncService } from '@/shared/services/sync/SyncService'

import { useEffect } from 'react'
import { useAuthStore } from '../stores/auth.store'

// This component now just initializes the auth listener
// It doesn't need to wrap children with a Context Provider anymore
export const AuthListener = ({ children }: { children: React.ReactNode }) => {
    const { setUser, setLoading, setNeedsOnboarding } = useAuthStore()

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
            try {
                if (firebaseUser) {
                    const profile = await getUserProfile(firebaseUser.uid)
                    const userData: LocalUser = buildLocalUser(firebaseUser, profile)

                    await db.users.put(userData)
                    setUser(userData)
                    setNeedsOnboarding(!userData.onboardingCompleted)
                    await syncService.initializeForUser(firebaseUser.uid)
                    setLoading(false)
                } else {
                    setUser(null)
                    setNeedsOnboarding(false)
                    setLoading(false)
                }
            } catch (error) {
                console.error('Failed to initialize auth state', error)
                setUser(null)
                setNeedsOnboarding(false)
                setLoading(false)
            }
        })

        return () => unsubscribe()
    }, [setUser, setLoading, setNeedsOnboarding])

    return <>{children}</>
}
